import { type IconProp } from '@fortawesome/fontawesome-svg-core';
import { faArrowUpRight, faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { type MessageDescriptor, useIntl } from 'react-intl';

import ActionBox from 'src/features/parkingActions/components/ActionBox';
import ActionsLayout from 'src/features/parkingActions/components/ActionsLayout';
import { actionMessages } from 'src/features/parkingActions/utils/messages';
import { PointAction, PointActionType } from 'src/features/points/types';
import {
    SectionBlockBody,
    SectionBlockHead,
    SectionBlockHeader,
    SectionBlock,
    SectionBlockSeparator,
    SectionBlockSubtitle,
    SectionBlockTitle,
} from 'src/registry/components/blocks/SectionBlock';

export type Action = {
    action: PointAction;
    actionType: PointActionType;
    title: MessageDescriptor;
    subtitle: MessageDescriptor;
    icon: IconProp;
};

export const barrierActions: Array<Action> = [
    {
        action: PointAction.OPEN_BARRIER,
        actionType: PointActionType.NORMAL,
        title: actionMessages.raiseBarrier,
        subtitle: actionMessages.chooseBarrierToRaise,
        icon: faArrowUpRight,
    },
];

export const emergencyBarrierActions: Array<Action> = [
    {
        action: PointAction.OPEN_BARRIER,
        actionType: PointActionType.EMERGENCY,
        title: actionMessages.emergencyRaiseBarrier,
        subtitle: actionMessages.raiseBarrierImmediately,
        icon: faTriangleExclamation,
    },
    {
        action: PointAction.CLOSE_BARRIER,
        actionType: PointActionType.EMERGENCY,
        title: actionMessages.emergencyLowerBarrier,
        subtitle: actionMessages.lowerBarrierImmediately,
        icon: faTriangleExclamation,
    },
];

const AllActions = () => {
    const { formatMessage } = useIntl();

    return (
        <ActionsLayout>
            <SectionBlock>
                <SectionBlockHeader>
                    <SectionBlockHead>
                        <SectionBlockTitle>{formatMessage(actionMessages.barriers)}</SectionBlockTitle>
                        <SectionBlockSubtitle>{formatMessage(actionMessages.barrierActions)}</SectionBlockSubtitle>
                    </SectionBlockHead>
                </SectionBlockHeader>
                <SectionBlockSeparator />
                <SectionBlockBody className="grid md:grid-cols-2 xl:grid-cols-3">
                    {barrierActions.map((action, index) => (
                        <ActionBox key={index} action={action} />
                    ))}
                </SectionBlockBody>
            </SectionBlock>

            <SectionBlock>
                <SectionBlockHeader>
                    <SectionBlockHead>
                        <SectionBlockTitle>{formatMessage(actionMessages.emergencyActions)}</SectionBlockTitle>
                        <SectionBlockSubtitle>
                            {formatMessage(actionMessages.performEmergencyAction)}
                        </SectionBlockSubtitle>
                    </SectionBlockHead>
                </SectionBlockHeader>
                <SectionBlockSeparator />
                <SectionBlockBody className="grid md:grid-cols-2 xl:grid-cols-3">
                    {emergencyBarrierActions.map((action, index) => (
                        <ActionBox key={index} action={action} variant="destructiveLight" />
                    ))}
                </SectionBlockBody>
            </SectionBlock>
        </ActionsLayout>
    );
};

export default AllActions;
